import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "euro"
})
export class EuroPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): string {
    if (typeof value === "number") {
      return this.numberToString(value);
    } else if (typeof value === "string") {
      const numberValue = parseFloat(value);
      return this.numberToString(numberValue);
    } else {
      return "-,-- €";
    }
  }

  private numberToString(value: number): string {
    return new Intl.NumberFormat("de-DE", {
      style: "currency",
      currency: "EUR" ,
      minimumFractionDigits: 2,
    }).format(value);
  }
}
